module.exports = __webpack_public_path__ + "img/200h100_dvukamernoe_s_fortochkoy_v_seredine_nizhney_chasti.6d8f992a.svg";